// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid'
import {
    Autocomplete,
    CardContent,
    Divider,
    FormControl,
    TextField,
    Typography,
} from '@mui/material'
import { useSearchParams } from "react-router-dom"
import axios from 'axios'

import Icon from '../../../components/icon'
import apiUrl from '../../../configs/constant'
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto'

import moment from 'moment'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2"
import Button from '@mui/material/Button'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast } = useToast()

    const [searchParams] = useSearchParams()

    // ? INIT DARI URL (sekali saja)
    const initTglAwal = searchParams.get('tglAwal') || moment().format('YYYY-MM-DD')
    const initTglAkhir = searchParams.get('tglAkhir') || moment().format('YYYY-MM-DD')
    const initAkun = searchParams.get('akun')

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(initTglAwal)
    const [tglAkhir, setTglAkhir] = useState<string>(initTglAkhir)

    const [valAkun, setValAkun] = useState<any>(null)
    const [listAkun, setListAkun] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getAkun()
    }, [])

    const getAkun = async () => {
        setListData([])

        try {
            let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-akun'

            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response.data.success) {
                let data = response.data.data || []

                // format label
                data = data.map((item: any) => ({
                    ...item,
                    nama: `${item.id} | ${item.nama}`
                }))

                setListAkun(data)

                // ? set akun dari URL
                if (initAkun) {
                    const found = data.find((e: any) => e.id == initAkun)
                    if (found) {
                        setValAkun(found)

                        // auto load
                        getData(found.id)
                    }
                }

            } else {
                showToast(response.data.message, 'error')
            }
        } catch (err) {
            showToast('Terjadi kesalahan', 'error')
        }
    }

    const getData = async (akunId?: any) => {
        const id = akunId || valAkun?.id

        if (!id) {
            showToast('Akun belum dipilih', 'error')
            return
        }

        Swal.fire({
            title: 'Now loading',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        })

        try {
            let url = apiUrl.apiUrl + '/acc/laporan-keuangan/buku-besar'

            const response = await axios.get(url, {
                params: {
                    accakun_id: id,
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                },
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response.data.success) {
                setListData(
                    (response.data.data || []).map((item: any, index: number) => ({
                        id: item.id ?? index + 1,
                        ...item
                    }))
                )
            } else {
                showToast(response.data.message, 'error')
            }

        } catch (err) {
            showToast('Terjadi kesalahan', 'error')
        } finally {
            Swal.close()
        }
    }

    const handleChangeAkun = (event: SyntheticEvent, newValue: any | null) => {
        setValAkun(newValue)
    }

    const convertComponent = [
        {
            key: 'dokumen',
            renderCell: ({ row }: any) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => window.open(row.data.link_dokumen, '_blank')}
                    >
                        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                            {row.data.dokumen}
                        </Typography>
                    </div>
                </Box>
            )
        },
    ]

    return (
        <Grid container spacing={3} justifyContent='center'>
            <Grid item xs={12}>
                <div className='content-block dx-card'>
                    <CardHeader title='BUKU BESAR' />
                    <Divider />

                    <CardContent>
                        <Grid container spacing={5}>

                            {/* Tanggal */}
                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label='Tanggal Awal'
                                    type='date'
                                    value={tglAwal}
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label='Tanggal Akhir'
                                    type='date'
                                    value={tglAkhir}
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            {/* Akun */}
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    value={valAkun}
                                    options={listAkun}
                                    isOptionEqualToValue={(o, v) => o.id === v.id}
                                    getOptionLabel={(o) => o.nama}
                                    onChange={handleChangeAkun}
                                    renderInput={(params) => (
                                        <TextField {...params} label='Akun' />
                                    )}
                                />
                            </Grid>

                            {/* Button */}
                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant='contained'
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                    disabled={!valAkun}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>

                        <MsiDatagrid
                            array={listData}
                            convertRupiah={['debet', 'kredit']}
                            hiddenColumns={['link_dokumen', 'id']}
                            customRender={convertComponent}
                        />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}